<template>
  <div class="basic-block block-chronology" :style="styles">
    <div class="content-wrap">
      <div class="block-chronology__inn">
        <img :src="`${path}chronology_head.png`" class="block-chronology__head" alt="あなたの10年の人生年表">
        <img :src="`${path}chronology_comment.png`" class="block-chronology__comment" alt="たとえば、1985年9月10日生まれのAさんは...">
        <img :src="`${path}chronology_table.png`" class="block-chronology__table" alt="人生年表">
        <img :src="`${path}chronology_message.png`" class="block-chronology__message" alt="あなたの10年を知って今を自由にもっと好きに生きてみてください">
        <lp-base-button
          label="今すぐ鑑定する"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
        <lead-login :color-scheme="colorScheme" />
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import LeadLogin from '@/utvStore/components/recommend/lp/partials/LeadLogin'

export default {
  name: 'BlockChronology',
  components: {
    LpBaseButton,
    LeadLogin,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: Number,
    subscriptionStatus: [ Number, null ],
    subscUrl: String,
  },
  data() {
    return {
      path: '/static/img/recommend/lp/kanoucoco/'
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    // サブスク登録済みのユーザーか
    isSubscUser() {
      return /^(0|1)$/.test(this.subscriptionStatus)
    },
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-products-button`,
      })
      if (this.isSubscUser) {
        location.href = this.$handoverParams(`/products/87/0001/result`)
      } else {
        location.href = this.$handoverParams(this.subscUrl)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-chronology {
  background: 
    url('/static/img/recommend/lp/kanoucoco/deco_wave.png') no-repeat 50% -56px/100% 112px,
    url('/static/img/recommend/lp/kanoucoco/deco_wave2.png') no-repeat 50% calc(100% + 56px)/100% 112px,
    url('/static/img/recommend/lp/kanoucoco/bg2.png') repeat 50% 0/375px auto;
  background-color: #FFECEB;
  font-family: "Hiragino Sans", sans-serif;
  padding: 24px 0 80px;
  &__inn {
    max-width: 520px;
    margin: auto;
  }
  &__head,
  &__comment,
  &__table,
  &__message {
    display: block;
    max-width: 100%;
    margin: auto;
  }
  &__head {}
  &__comment { margin-top: -1px; }
  &__table { width: 89.333%; margin-top: -3px; }
  &__message { width: 89.333%; margin: 24px auto 40px;}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockChronology.vue